import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-thankyou',
    templateUrl: './thankyou.component.html',
    styleUrl: './thankyou.component.scss',
    standalone: false
})
export class ThankyouComponent {

  constructor(private router: Router) {
  }
  RedirectToHome(){
    this.router.navigate(['home']);
  }

}
